<template>
  <div>
    <input-form
      :inputData="collectInfoFormList"
      @toParentVal="searchCollectOpportunities"
      :btnPosition1="true"
      style="margin: 20px 0"
    />
    <div class="mb12">
      <el-button
        style="width: auto;"
        @click="addCrowd"
        :disabled="!collectOpportunitiesList.length"
        >按查询结果生成人群</el-button
      >
      <el-button style="width: auto;" @click="isShowAddGiftNumberBatch = true"
        >收集次数变更（批量）</el-button
      >
      <el-button
        style="width: auto;"
        @click="exportCollect"
        type="primary"
        v-preventReClick
        >导出</el-button
      >
    </div>
    <!-- 表格 -->
    <el-table
      :data="collectOpportunitiesList"
      style="width: 100%;"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
      v-loading="loading"
    >
      <template slot="empty">
        <div>
          <img
            src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
          />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
      </el-table-column>
      <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
      <el-table-column prop="taskTypeStr" label="获取方式">
        <template slot-scope="scope">
          <span>{{ scope.row.taskTypeStr ? scope.row.taskTypeStr : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveTimes" label="赠送机会次数"></el-table-column>
      <el-table-column label="许愿心愿">
        <template slot-scope="scope">
          <span>{{
            scope.row.wishContent
              ? scope.row.wishContent
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="获取时间">
        <template slot-scope="scope">
          <span>{{ scope.row.joinTime ? scope.row.joinTime : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 25px"
      @size-change="handleSizeChange"
      background
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="collectForm.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="collectOpportunitiesTotal"
      :current-page="collectForm.current"
    ></el-pagination>
    <!-- 收集次数变更（批量） -->
    <addGiftNumberBatch
      v-if="isShowAddGiftNumberBatch"
      titleText="收集"
      :activityId="activityId"
      @close="handleCloseAddGiftNumberBatch"
    ></addGiftNumberBatch>
  </div>
</template>
<script>
import { gameTaskRecord } from "@/api/integralCenter/PointActivityAnalyticController";
import inputForm from "@/components/inputForm.vue";
import addGiftNumberBatch from "./addGiftNumberBatch.vue";
export default {
  name: "birthInfo",
  components: {
    inputForm,
    addGiftNumberBatch,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowAddGiftNumberBatch: false,
      collectInfoFormList: [
        {
          name: "用户PIN：",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获取方式：",
          val: "taskType",
          placeholder: "请选择获取方式",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "许愿赠送", id: 21 },
            { label: "手动变更", id: 19 },
            { label: "每日签到", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 3 },
            { label: "加购商品", id: 4 },
            { label: "分享商品", id: 9 },
            { label: "分享店铺", id: 10 },
            { label: "分享活动", id: 11 },
            { label: "浏览会场", id: 5 },
            { label: "预约商品", id: 12 },
            { label: "积分兑换", id: 16 },
            { label: "购买商品", id: 17 },
            { label: "加入会员", id: 7 },
            { label: "关注店铺", id: 6 },
            { label: "预售商品", id: 20 },
          ],
        },
        {
          name: "获取时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      loading: false,
      collectOpportunitiesTotal: 0,
      collectOpportunitiesList: [],
      collectForm: {
        sellerLinkId: "",
        pin: "",
        taskType: "",
        startTime: "",
        endTime: "",
        size: 10,
        current: 1,
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getCollectOpportunitiesDetail();
  },
  methods: {
    handleCloseAddGiftNumberBatch(flag) {
      this.isShowAddGiftNumberBatch = false;
      if (flag) {
        this.getCollectOpportunitiesDetail();
      }
    },
    // 导出获取机会记录
    exportCollect() {
      this.$emit("exportTask");
    },
    addCrowd() {
      this.$emit("addCrowd", 7);
    },
    handleSizeChange(val) {
      this.collectForm.size = val;
      this.getCollectOpportunitiesDetail();
    },
    handleCurrentChange(val) {
      this.collectForm.current = val;
      this.getCollectOpportunitiesDetail();
    },
    getCollectOpportunitiesDetail() {
      this.loading = true;
      gameTaskRecord({ ...this.collectForm, activityId: this.activityId })
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.collectOpportunitiesList = res.data.records || [];
            this.collectOpportunitiesTotal = +res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    searchCollectOpportunities(val) {
      this.collectForm.pin = val.pin ? val.pin : "";
      this.collectForm.memberNick = val.memberNick ? val.memberNick : "";
      this.collectForm.taskType = val.taskType ? val.taskType : "";
      this.collectForm.startTime = val.startTime ? val.startTime : "";
      this.collectForm.endTime = val.endTime ? val.endTime : "";
      this.collectForm.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.collectForm.size = 10;
      this.collectForm.current = 1;
      this.getCollectOpportunitiesDetail();
    },
    handleSizeChange(val) {
      this.collectForm.size = val;
      this.getCollectOpportunitiesDetail();
    },
    handleCurrentChange(val) {
      this.collectForm.current = val;
      this.getCollectOpportunitiesDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
.mb12 {
  margin-bottom: 12px;
}
</style>
